import { getEntityRef, getRootContainerProps } from "@client/content/lib/helper";
import FormStyleProvider from "@client/content/Providers/FormStyle/container";
import { type RootContainerProps } from "@client/content/types";
import { type WithIsEditMode } from "@client/types";
import * as React from "react";
import LeaderboardGrid from "../../../shared/Leaderboard/component";
import { type Leaderboard } from "../types";
import ApplyModal from "./ApplyModal/container";
import ApplyNow from "./ApplyNow/container";
import ProfileModal from "./ProfileModal/container";
import VoteModal from "./VoteModal/container";

export type MapProps = RootContainerProps &
  WithIsEditMode & {
    current: Leaderboard.Item | null;
    hasMore: boolean;
    isLoading: boolean;
    isMobile: boolean;
    referring: Leaderboard.Item | null;
    rewards: Leaderboard.Reward[];
    status: string;
    topTitle: string | null;
    type: Leaderboard.ItemType;
    items: Leaderboard.Item[];
  };

export interface ActionProps {
  onLoadNextPage: () => void;
  onClickItem?: (item: Leaderboard.Item) => void;
}

export default (props: ActionProps & MapProps) => {
  if (props.status === "Failed") {
    if (props.isEditMode) return <div>The module has failed to load</div>;

    return null;
  }

  return (
    <FormStyleProvider {...getEntityRef(props)}>
      <div>
        {props.type === "launch" && <ApplyNow {...getEntityRef(props)} />}
        {props.topTitle && <p className="top_info">{props.topTitle}</p>}
        <LeaderboardGrid
          onLoadNextPage={props.onLoadNextPage}
          current={props.current}
          hasMore={props.hasMore}
          isLoading={props.isLoading}
          isMobile={props.isMobile}
          referring={props.referring}
          rewards={props.rewards}
          topTitle={props.topTitle}
          type={props.type}
          items={props.items}
          onClickItem={props.onClickItem}
        />
        {props.type === "launch" && <ApplyModal {...getRootContainerProps(props)} />}
        {props.type === "launch" && <ProfileModal {...getRootContainerProps(props)} />}
        {props.type === "launch" && <VoteModal {...getRootContainerProps(props)} />}
      </div>
    </FormStyleProvider>
  );
};
